import {useIsBotModeEnabled} from '@aboutyou/data-fetcher';
import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {PropsWithChildren} from 'react';

export const PageContentWrapper: React.FC<PropsWithChildren> = ({children}) => {
  const isBotMode = useIsBotModeEnabled();
  const {t} = useTranslation();

  return (
    /**
     * The "id=page-content-wrapper" is used to alter the min-height from a page level
     * by adding extra css to this id.
     * This avoids having the PageContentWrapper being moved to page level or passing down
     * callbacks to achieve page specific behavior.
     *
     * @see 'packages/core/application-desktop/src/bridge/pages/Checkout.eager.tsx'
     */
    <StyledMain
      id="page-content-wrapper"
      $withMinHeight={!isBotMode}
      data-skip-link={t('Skip to main content')}
    >
      {children}
    </StyledMain>
  );
};

// Giving a min height with height of Header(+ Campaign Banner)
// This is important to prevent CLS on loading states to push the footer below the fold
const StyledMain = styled.main<{$withMinHeight: boolean}>`
  min-height: ${({$withMinHeight}) =>
    $withMinHeight ? 'calc(100vh - (188px + 44px))' : 'unset'};
`;
